import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AdminShellComponent } from './shell.component';

@NgModule({
  declarations: [AdminShellComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule],
  exports: [AdminShellComponent],
})
export class AdminShellModule {}
